module.exports = __webpack_public_path__ + "static/img/hover10.dff05645.png";